import BApp from "../BApp";
import BCaloricCalculator from "./BCaloricCalculator";

export default class BFrontCaloricCalculator extends BCaloricCalculator
{
	static selector = () => `.b-caloric-calculator--front`;

	static initialize()
	{
		document.querySelectorAll(this.selector()).forEach(el => {
			new this(el);
		});

		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener('submit', event => {
			if (event.target.matches(this.selector())) {
				event.preventDefault();

				const caloricCalculator = new this(event.target.closest(this.selector()));
				caloricCalculator.getResult();
			}
		});

		document.addEventListener('click', event => {
			const selector = `${this.selector()} [type="submit"]`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				event.preventDefault();

				const caloricCalculator = new this(event.target.closest(this.selector()));
				caloricCalculator.getResult();
			}
		});

		document.addEventListener('click', event => {
			const selector = `${this.selector()} .caloric-calculator__recalculate-button`;
			if (event.target.matches(selector)) {
				event.preventDefault();

				const caloricCalculator = new this(event.target.closest(this.selector()));
				caloricCalculator.showInput();
				caloricCalculator.hideOutput();
			}
		});
	}

	setResponse(response)
	{
		const payload = response.data || {};
		if (payload.session && payload.session.url) {
			BApp.setUrl(payload.session.url);
		}

		const wrapped = payload.calculator && payload.calculator.output && payload.calculator.output.metrics;
		const metrics = wrapped || Object.keys(payload).map((name) => {
			const metric = payload[name] || {};
			const code = metric.metric && metric.metric.code ? metric.metric.code : name;

			return {
				name: code,
				formatted: metric.formatted,
				result: typeof metric.result === "number" ? metric.result : 0,
			};
		});

		for (let metric of metrics) {
			this.setOutputMetric(metric);
		}

		this.hideInput();
		this.showOutput();
		this.scrollToTop();

		// for (let j in response.data.output.messages) {
		// 	form.caloricCalculatorAddOutputMessage(response.data.output.messages[j].message);
		// }

		// window.OneSignal = window.OneSignal || [];
		// window.OneSignal.push(function() {
		// 	window.OneSignal.sendTags({
		// 		segment: "caloricCalculator",
		// 		reference: form.attr('data-reference'),
		// 	});
		// });
	}
}
